var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SteemTxUtils } from '@popup/steem/utils/steem-tx.utils';
const powerUp = (from, to, amount, activeKey, options) => __awaiter(void 0, void 0, void 0, function* () {
    return SteemTxUtils.sendOperation([getPowerUpOperation(from, to, amount)], activeKey, false, options);
});
const powerDown = (username, amount, activeKey, options) => __awaiter(void 0, void 0, void 0, function* () {
    return SteemTxUtils.sendOperation([getPowerDownOperation(username, amount)], activeKey, false, options);
});
const getPowerUpOperation = (from, to, amount) => {
    return [
        'transfer_to_vesting',
        {
            from: from,
            to: to,
            amount: amount,
        },
    ];
};
const getPowerDownOperation = (username, amount) => {
    return [
        'withdraw_vesting',
        {
            account: username,
            vesting_shares: amount,
        },
    ];
};
const getPowerUpTransaction = (from, to, amount) => {
    return SteemTxUtils.createTransaction([
        PowerUtils.getPowerUpOperation(from, to, amount),
    ]);
};
const getPowerDownTransaction = (username, amount) => {
    return SteemTxUtils.createTransaction([
        PowerUtils.getPowerDownOperation(username, amount),
    ]);
};
export const PowerUtils = {
    powerUp,
    powerDown,
    getPowerDownOperation,
    getPowerUpOperation,
    getPowerUpTransaction,
    getPowerDownTransaction,
};
